import React, { useContext, useState } from "react";
import * as FaIcons from "react-icons/fa";
import RegistrationContext from "../../../context/registration/registrationContext";
import SubFormButtons from "../SubFormButtons";
import ProgressButtons from "../ProgressButtons";
import { useEffect } from "react";
import findBrand from "../../findBrand";
import { brandDomains, fetchBrands } from "../../brand";

const R15ParentCustodyInformation = ({ validateFormData, submitted }) => {
  const registrationContext = useContext(RegistrationContext);
  const {
    subFormLevels,
    // onFormDataChange,
    formData: {
      firstName,
      custodyIssueExists,
      custodyIssueNotes,
      legalRestrictionsForAnyParent,
      legalRestrictionsNotes,
    },
    onFormDataChange,
    pass: { parentCustody },
  } = registrationContext;

  const handleChange = (e) => {
    const value = e.target.value;
    e.target.value =
      value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    onFormDataChange(e);
  };

  const ParentCustody =
    custodyIssueExists !== "" &&
    (custodyIssueExists["no"] ||
      (custodyIssueExists["yes"] && custodyIssueNotes !== "")) &&
    legalRestrictionsForAnyParent !== "" &&
    (legalRestrictionsForAnyParent["no"] ||
      (legalRestrictionsForAnyParent["yes"] && legalRestrictionsNotes !== ""));

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = "Are you sure you want to leave?";
      event.returnValue = message;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
       const loadBrands = async () => {
         await fetchBrands();
       };
   
       loadBrands();
     }, []);
  
     const brand_holston = brandDomains.brand_holston?.name;
     const brand_pbia = brandDomains.brand_pbia?.name;

  //findBrand is used to check whether holston forms or other forms
  if (findBrand(brand_holston) === true || findBrand(brand_pbia)=== true) {
    return (
      <>
        <div className="sub-form">
          <h2 className="">
            Parent Custody Information <span>(11/11)</span>
            <hr />
          </h2>
          <div className="item">
            <div className="asterisk-group">
              {/* <h3>Do Any Custody Issues Exists for the Student?</h3> */}
              <h3>
                Do any Custody Issues Exist for{" "}
                {firstName === "" ? "the Student" : firstName}?
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <div
              className="flex-check-container"
              style={{
                border:
                  submitted && custodyIssueExists === ""
                    ? "2px solid #d8302f"
                    : // : "1px solid #ccc",
                      "",
              }}
            >
              <label className="check-container">
                Yes
                <input
                  type="radio"
                  value="yes"
                  checked={custodyIssueExists["yes"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="custodyIssueExists"
                />
                <span className="styled-checkmark"></span>
              </label>
              <label className="check-container">
                No
                <input
                  type="radio"
                  value="no"
                  checked={custodyIssueExists["no"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="custodyIssueExists"
                />
                <span className="styled-checkmark"></span>
              </label>
            </div>
          </div>
          {custodyIssueExists["yes"] && (
            <div className="item">
              <div className="asterisk-group">
                <h3>Custody Issue Notes </h3>
              </div>
              <textarea
                name="custodyIssueNotes"
                cols="30"
                rows="4"
                onChange={handleChange}
                value={custodyIssueNotes}
              ></textarea>
            </div>
          )}

          <div className="item">
            <div className="asterisk-group">
              <h3>
                Are there any Legal Restrictions for{" "}
                {firstName === "" ? "the Student" : firstName}'s Parents?
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <div
              className="flex-check-container"
              style={{
                border:
                  submitted && legalRestrictionsForAnyParent === ""
                    ? "2px solid #d8302f"
                    : // : "1px solid #ccc",
                      "",
              }}
            >
              <label className="check-container">
                Yes
                <input
                  type="radio"
                  value="yes"
                  checked={legalRestrictionsForAnyParent["yes"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="legalRestrictionsForAnyParent"
                />
                <span className="styled-checkmark"></span>
              </label>
              <label className="check-container">
                No
                <input
                  type="radio"
                  value="no"
                  checked={legalRestrictionsForAnyParent["no"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="legalRestrictionsForAnyParent"
                />
                <span className="styled-checkmark"></span>
              </label>
            </div>
          </div>
          {legalRestrictionsForAnyParent["yes"] && (
            <div className="item">
              <div className="asterisk-group">
                <h3>Legal Restriction Notes </h3>
              </div>
              <textarea
                name="legalRestrictionsNotes"
                cols="30"
                rows="4"
                onChange={handleChange}
                value={legalRestrictionsNotes}
              ></textarea>
            </div>
          )}
          <div className="group">{subFormLevels.parentCustody === 0}</div>
        </div>
        <ProgressButtons validation={ParentCustody} name="parentCustody" />
      </>
    );
  } else {
    return (
      <>
        <div className="sub-form">
          <h2 className="">
            Parent Custody Information <span>(14/15)</span>
            <hr />
          </h2>
          <div className="item">
            <div className="asterisk-group">
              <h3>
                Do any Custody Issues Exist for{" "}
                {firstName === "" ? "the Student" : firstName}?
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <div
              className="flex-check-container"
              style={{
                border: parentCustody
                  ? "1px solid #ccc;"
                  : custodyIssueExists !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <label className="check-container">
                Yes
                <input
                  type="radio"
                  value="yes"
                  checked={custodyIssueExists["yes"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="custodyIssueExists"
                />
                <span className="styled-checkmark"></span>
              </label>
              <label className="check-container">
                No
                <input
                  type="radio"
                  value="no"
                  checked={custodyIssueExists["no"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="custodyIssueExists"
                />
                <span className="styled-checkmark"></span>
              </label>
            </div>
          </div>
          {custodyIssueExists["yes"] && (
            <div className="item">
              <div className="asterisk-group">
                <h3>Custody Issue Notes </h3>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <textarea
                name="custodyIssueNotes"
                cols="30"
                rows="4"
                onChange={handleChange}
                value={custodyIssueNotes}
                style={{
                  border: parentCustody
                    ? "1px solid #ccc;"
                    : custodyIssueNotes !== ""
                    ? "1px solid #ccc"
                    : "#d8302f 2px solid",
                }}
              ></textarea>
            </div>
          )}

          <div className="item">
            <div className="asterisk-group">
              <h3>
                Are there any Legal Restrictions for{" "}
                {firstName === "" ? "the Student" : firstName}'s Parents?
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <div
              className="flex-check-container"
              style={{
                border: parentCustody
                  ? "1px solid #ccc;"
                  : legalRestrictionsForAnyParent !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <label className="check-container">
                Yes
                <input
                  type="radio"
                  value="yes"
                  checked={legalRestrictionsForAnyParent["yes"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="legalRestrictionsForAnyParent"
                />
                <span className="styled-checkmark"></span>
              </label>
              <label className="check-container">
                No
                <input
                  type="radio"
                  value="no"
                  checked={legalRestrictionsForAnyParent["no"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="legalRestrictionsForAnyParent"
                />
                <span className="styled-checkmark"></span>
              </label>
            </div>
          </div>
          {legalRestrictionsForAnyParent["yes"] && (
            <div className="item">
              <div className="asterisk-group">
                <h3>Legal Restriction Notes </h3>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <textarea
                name="legalRestrictionsNotes"
                cols="30"
                rows="4"
                onChange={handleChange}
                value={legalRestrictionsNotes}
                style={{
                  border: parentCustody
                    ? "1px solid #ccc;"
                    : legalRestrictionsNotes !== ""
                    ? "1px solid #ccc"
                    : "#d8302f 2px solid",
                }}
              ></textarea>
            </div>
          )}
          <div className="group">{subFormLevels.parentCustody === 0}</div>
        </div>
        <ProgressButtons validation={ParentCustody} name="parentCustody" />
      </>
    );
  }
};
export default R15ParentCustodyInformation;
